import React from 'react';
import { Col, Select } from 'antd';
import * as etiquetas from '../../../ApplicationResources';

const { Option } = Select;

const VFiltrosCombo = ({ procesos, proceso, estado, distrito, usuario, rolUsuario, listaEstados, listaDistritos,
                        seleccionaProceso, seleccionaEstado, seleccionaDistrito }) => {
    return(
        <div className='fmc-combos'>
            <Col xs={24} sm={24} md={24} lg={5}>
                <div className='fmc-combos-combo'>
                    <span className='fmc-combos-combo-text-entidad'>
                        {
                            etiquetas.MENU_FILTROS_ESTADO
                        }
                    </span>
                    {
                        rolUsuario !== "JD"
                        && rolUsuario !== "JL" ?
                        <Select showArrow={true}
                            value={estado ? estado.nombreEstado : etiquetas.MENU_FILTROS_PROCESOS_LABEL_0}
                            onSelect={seleccionaEstado}>
                            {
                            listaEstados &&
                            listaEstados.map((estado) => (
                                <Option key={estado.idEstado}
                                    value={estado.idEstado}>
                                    {estado.nombreEstado}
                                </Option>
                            ))
                            }
                        </Select>
                        : <span className='fmc-combos-combo-label'>{estado ? estado.nombreEstado : usuario.estado}</span>
                    }
                </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={8}>
                <div className='fmc-combos-combo'>
                    <span className='fmc-combos-combo-text'>
                        {etiquetas.MENU_FILTROS_PROCESOS}
                    </span>

                    <Select showArrow={true} disabled={proceso===undefined ? true : false}
                        value={proceso ? proceso.descripcionDetalleLarga: etiquetas.MENU_FILTROS_PROCESOS_LABEL_0}
                        onSelect={seleccionaProceso}>
                        {
                        procesos &&
                        procesos.map((proceso) => (
                            <Option key={proceso.idDetalleProceso}
                                value={proceso.idDetalleProceso}>
                                {proceso.descripcionDetalleLarga}
                            </Option>
                        ))
                        }
                    </Select>
                </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={6}>
                <div className='fmc-combos-combo'>
                    <span className='fmc-combos-combo-text'>
                        {etiquetas.MENU_FILTROS_DISTRITO}
                    </span>
                    {
                        rolUsuario === "OC" || rolUsuario === 'JL' ?
                        <Select showArrow={true} disabled={distrito===undefined ? true : false}
                            value={`${distrito && distrito.idDistrito > 0 && distrito.nombreDistrito ?  distrito.idDistrito+'-'+distrito.nombreDistrito : etiquetas.MENU_FILTROS_DISTRITO_LABEL_0}
                                    `}
                            onChange={seleccionaDistrito}>
                            {
                                listaDistritos &&
                                listaDistritos.map((distrito) => (
                                    <Option key={distrito.idDistrito}
                                        value={distrito.idDistrito}>
                                        {`${distrito.idDistrito > 0 ?  distrito.idDistrito+'-' : ''}
                                        ${distrito.nombreDistrito}`}
                                    </Option>
                                ))
                            }
                        </Select>
                        : <span className='fmc-combos-combo-label'>{usuario.idDistrito + ". " + usuario.distrito}</span>
                    }
                </div> 
            </Col>
        </div>
    );
}

export default VFiltrosCombo;